/**
 * Client-side ID generator. Mirrors the server's Base58 format
 * (88 bits of entropy, 16 chars) so frontend-minted IDs sit alongside
 * server-minted ones without visual or collision concerns.
 */

const ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
const ENTROPY_BYTES = 11; // 88 bits
const SUFFIX_CHARS = 16; // 58^16 > 2^88

function suffix(): string {
	const bytes = new Uint8Array(ENTROPY_BYTES);
	crypto.getRandomValues(bytes);

	let value = 0n;
	for (const b of bytes) value = (value << 8n) | BigInt(b);

	const chars = new Array<string>(SUFFIX_CHARS);
	for (let i = SUFFIX_CHARS - 1; i >= 0; i--) {
		const rem = Number(value % 58n);
		value /= 58n;
		chars[i] = ALPHABET[rem];
	}
	return chars.join("");
}

export function newMessageId(): string {
	return `msg_${suffix()}`;
}

export function newRequestId(): string {
	return `req_${suffix()}`;
}
